import {Routes} from '@angular/router';
import {EditPostingComponent} from './components/edit-posting/edit-posting.component';
import {NewPostingComponent} from './components/new-posting/new-posting.component';
import {UnsavedPostGuard} from './unsaved-post.guard';
import { AgreementsGuard, GUARDS } from 'smartauction-frontend-micro-library';
import {AuthGuard, LaunchDarklyUserGuard, PostingTypes} from 'remarketing-angular-library';
import {AmbassadorGuard} from '../../../app/guards/ambassador/ambassador.guard';

export const postingRoutes: Routes = [
  {
    path: 'post',
    component: NewPostingComponent,
    canActivate: [
      AuthGuard,
      AgreementsGuard,
      AmbassadorGuard,
      LaunchDarklyUserGuard
    ],
    data: {
      flag: 'menu-sellEnabled',
      guards: [
        GUARDS.TermsOfUseGuard,
        GUARDS.PrivacyPolicyGuard
      ]
    },
  },
  {
    path: 'post/:vin',
    component: EditPostingComponent,
    canDeactivate: [UnsavedPostGuard],
    canActivate: [
      AuthGuard,
      AgreementsGuard,
      AmbassadorGuard
    ],
    data: {
      postingType: PostingTypes.NEW,
      guards: [
        GUARDS.TermsOfUseGuard,
        GUARDS.PrivacyPolicyGuard
      ]
    },
  },
  {
    path: 'edit/:inventoryItemUuid',
    component: EditPostingComponent,
    data: {postingType: PostingTypes.EDIT},
    canDeactivate: [UnsavedPostGuard],
    canActivate: [
      AmbassadorGuard
    ]
  },
  {
    path: 'repost/:inventoryItemUuid',
    component: EditPostingComponent,
    data: {postingType: PostingTypes.REPOST_BEFORE_60_DAYS},
    canDeactivate: [UnsavedPostGuard],
    canActivate: [
      AmbassadorGuard
    ]
  }
];

